// Helper to get local date and decimal time dynamically on startup
const getLocalInstant = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const date = `${yyyy}-${mm}-${dd}`;
  const time = parseFloat((now.getHours() + now.getMinutes() / 60).toFixed(2));
  return { date, time };
};

const currentInstant = getLocalInstant();

export const CONFIG = {
  apiKey: "AIzaSyCAw1DWWd-ophYbaZJvCvysBJYT7zOylio",
  mapId: "7780b551c3eb7d2c78f1748a",
  defaults: {
    lat: 39.051605,
    lng: -94.480402,
    alt: -0.8,
    rotation: 46.3,
    scale: 0.85,
    date: currentInstant.date,
    time: currentInstant.time,
    mapsEnabled: false,
    baseScale: 1.174947733769433,
    stadiumName: "Stadium_KC.glb"
  }
};
